import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setMetaZones: Mutation<IModuleState> = (state, payload) => {
  state.zones.data = payload.data;
  state.zones.pageNum = payload.pageNum;
  state.zones.pageSize = payload.pageSize;
  state.zones.total = payload.total;
  state.zones.loading = !!payload.loading;
};

export const setZoneDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
